import React, { Component } from 'react';

const datefor = new Intl.DateTimeFormat('en-GB', { 
		weekday: 'short',
        year: 'numeric', 
        month: 'short', 
        day: '2-digit' 
    });

export default class JobsForJpin extends Component{
	constructor(props) {
		super(props);
		this.state = {

		};
	}

	render() {
		var loc = this.props.loc;
		return(
			<div className="putaway-product" style={{marginTop:'15px'}}>
				<div className="row">
					<div className="col-md-12">
						<div className="pull-right">{loc.jobExecutionStepStatus}</div>
					</div>
				</div>
				<div className="row">
					<div className="col-xs-6 col-sm-3 col-md-3">
						<div className="putaway-product-label">Job Exec Id</div>
						<div className="putaway-product-value" style={{marginTop:'15px'}}>{loc.jobExecutionStepId}</div>
					</div>
					<div className="col-xs-6 col-sm-3 col-md-3">
						<div className="putaway-product-label">Space Name</div>
						<div className="putaway-product-value" style={{marginTop:'15px'}}>{loc.inwardingSpaceName}</div>
					</div>
					<div className="col-xs-6 col-sm-3 col-md-3 top-ten-xs">
						<div className="putaway-product-label">Quantity</div>
						<div className="putaway-product-value" style={{marginTop:'15px'}}>{loc.qty}</div>
					</div>
					<div className="col-xs-6 col-sm-3 col-md-3 top-ten-xs">
						<div className="putaway-product-label">Created Time</div>
						<div className="putaway-product-value" style={{marginTop:'15px'}}>{datefor.format(loc.createdTime)}</div>
					</div>
				</div>
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/screens/JobOperations/Components/Commons/JobsForJpin.js